// extracted by mini-css-extract-plugin
export var backdropBlur = "_5x-0";
export var body = "_5x-5";
export var bodyScroll = "_5x-6";
export var columnFooter = "_5x-7";
export var columnFooterFlush = "_5x-8";
export var contentColumn = "_5x-4";
export var frame = "_5x-3";
export var heroContent = "_5x-c";
export var heroOverlay = "_5x-b";
export var image = "_5x-a";
export var imageWrapper = "_5x-9";
export var modal = "_5x-1";
export var modalMain = "_5x-2";
export var productHeader = "_5x-d";
export var productHeaderIcon = "_5x-e";
export var productHeaderName = "_5x-f";
export var progressIndicator = "_5x-g";